import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import Popup from './../popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';

export class ConfigCalendar extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      resources: [],
      services: [],
      profiles: [],
      loading: true,
      date: curDate,
      calendarType: 1,
      company: {startTime: "09:00:00", endTime: "20:00:00"},
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
  }

  componentDidMount() {
    if (this.state.companyId === 0)
      this.populateCompaniesData();
    else {
      this.populateResourcesData(this.state.companyId, this.state.date);
      this.populateWorkingTimeData(this.state.companyId);
      this.populateProfilesData(this.state.companyId);
    }
  }

  prevMonth() {
    var date = this.state.date;
    date.setMonth(this.state.date.getMonth() - 1);
    this.setState(prevState => ({...prevState, date: date}));
    this.populateResourcesData(this.state.companyId, this.state.date);
  }

  nextMonth() {
    var date = this.state.date;
    date.setMonth(this.state.date.getMonth() + 1);
    this.setState(prevState => ({...prevState, date: date}));
    this.populateResourcesData(this.state.companyId, this.state.date);
  }

  async setDay(resource, day) {
    var resources = this.state.resources;
    var remove = resource.workingDays.includes(day);
    if (remove)
      resource.workingDays = resource.workingDays.filter(d => d !== day);
    else
      resource.workingDays.push(day);
    this.setState(prevState => ({...prevState, resources: resources}));

    var selectedDate = new Date(this.state.date.getFullYear(), this.state.date.getMonth(), day);
    var date = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000);
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/resources/${resource.id}/calendar`, {
      method: remove ? "DELETE" : "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({day: date, allDays: day === 0, dayOfWeek: day < 0 ? -day : null})
    });
    await response.json();
  }

  renderParamOptions(resource, day, val) {
    return (
      <>
      <h4>{resource.name} ({day})</h4>
      <div class="btndelete" onClick={() => this.setDay(resource, day)}>Delete all configuration for the selected day</div>

      <div class="tablediv">

        <div>Assign services and override prices</div>
        <table className='table table-striped' aria-labelledby="tabelLabel">
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th>Price</th>
              <th>MinTime</th>
              <th>MaxTime</th>
              <th>Editable</th>
            </tr>
          </thead>
          <tbody>
            {this.state.services.filter(service => service.assigned).map(service =>
              <tr key={service.id} onClick={() => this.selectParmaService(service)} class={this.state.paramservice?.id === service.id?'react-calendar__tile--active':''}>
                <td>{service.id}</td>
                <td>{service.name}</td>
                <td>{service.price}</td>
                <td>{service.minTime}</td>
                <td>{service.maxTime}</td>
                <td>{service.timeEditable ? '+' : ''}</td>
              </tr>
            )}
          </tbody>
        </table>

      </div>
        <div class="form-group">
          <label for="Input_BookingProfile">Resource booking profile</label>
          <select class="form-control" id="Input_BookingProfile" name="Input.BookingProfile"
            value={val.profileId ? val.profileId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resource: {...prevState.param, profileId: parseInt(val)}}));}}>
              <option value="0"></option>
              {this.state.profiles.map(profile => <option value={profile.id}>{profile.name}</option>)}
          </select>
        </div>

        <div class="form-group">
          <label for="Input_ServicePrice">Service price</label>
          <input class="form-control" type="text" id="Input_ServicePrice" name="Input.ServicePrice"
            value={val.price !== undefined ? val.price : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, price: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMinTime">Service minimum duration in hours</label>
          <input class="form-control" type="text" id="Input_ServiceMinTime" name="Input.ServiceMinTime"
            value={val.minTime !== undefined ? val.minTime : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.param, minTime: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMaxTime">Service maximum duration in hours</label>
          <input class="form-control" type="text" id="Input_ServiceMaxTime" name="Input.ServiceMaxTime"
            value={val.maxTime !== undefined ? val.maxTime : '8760'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.param, maxTime: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_BookingInterval">Service booking interval</label>
          <select class="form-control" id="Input_BookingInterval" name="Input.BookingInterval"
            value={val.bookingInterval ? val.bookingInterval.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.param, bookingInterval: val}}));}}>
              <option value="1">1 min</option>
              <option value="2">5 min</option>
              <option value="3">1 hour</option>
              <option value="4">1 day</option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_PartialBooking">Partial booking settings</label>
          <select class="form-control" id="Input_PartialBooking" name="Input.PartialBooking"
            value={val.partialBooking ? val.partialBooking.toString() : 'null'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.param, partialBooking: val === 'null' ? null : val}}));}}>
              <option value="null">Off</option>
              <option value="2">2 members</option>
              <option value="3">3 members</option>
              <option value="4">4 members</option>
              <option value="5">5 members</option>
              <option value="6">6 members</option>
              <option value="7">7 members</option>
              <option value="8">8 members</option>
              <option value="9">9 members</option>
              <option value="10">10 members</option>
          </select>
        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" type="button" value="Save" id="Button_Save" onClick={() => this.handleSaveFilter(val)}/>
      </>
    );
  }

  renderCalendarTable() {
    var date = this.state.date;
    var daysinmonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    return (
      <>
      
        <div><span className="radio-primary">
            <input name="CalendarType" type="radio" value="RadioOwn" id="RadioOwn" checked={this.state.calendarType === 1} onClick={() => this.setState(prevState => ({...prevState, calendarType: 1}))}/><label className="btn btn-primary btn-tab" for="RadioOwn">По датам</label>
            <input name="CalendarType" type="radio" value="RadioOther" id="RadioOther" checked={this.state.calendarType === 2} onClick={() => this.setState(prevState => ({...prevState, calendarType: 2}))}/><label className="btn btn-primary btn-tab" for="RadioOther">По дням недели</label>
            </span>
            </div>
      
      {this.state.calendarType==1?
      <><table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th width="16px" onClick={() => this.prevMonth()}>&lt;</th>
            <th colspan={daysinmonth}>{this.state.date.toLocaleString(undefined, {month: '2-digit', year: 'numeric'})}</th>
            <th width="16px" onClick={() => this.nextMonth()}>&gt;</th>
          </tr>
        </thead>
      </table>
      <div class="tabledivmid">

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr key="days">
            <th></th>
            <td>All</td>
            {Array.from(Array(daysinmonth).keys()).map(pos => <td class={new Date(date.getFullYear(), date.getMonth(), pos + 1).getDay() === 0 || new Date(date.getFullYear(), date.getMonth(), pos + 1).getDay() === 6 ? "day-weekend" : ""}>{pos + 1}</td>)}
            <td></td>
          </tr>
        </thead>
        <tbody>
          {this.state.resources.map(resource =>
            <tr key={resource.name}>
              <th>{resource.name}</th>
              {resource.workingDays.includes(0)?
                <Popup
                  className="popup-info"
                  trigger={open => <td class="react-calendar__tile--active filteroptcal"></td>}
                  position="bottom center"
                  onOpen={() => this.populateServicesData(this.state.companyId, resource.id)}
                  closeOnDocumentClick>{() => this.renderParamOptions(resource, 0, {})}</Popup>
              :<td onClick={() => this.setDay(resource, 0)}></td>
              }
              {Array.from(Array(daysinmonth).keys()).map(pos => <td onClick={() => this.setDay(resource, pos + 1)} className={resource.workingDays.includes(pos + 1)?'react-calendar__tile--active':''}></td>)}
              <td></td>
            </tr>
          )}
        </tbody>
      </table>

      </div></>:<></>}

      {this.state.calendarType==2?
      <div class="tabledivmid">

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <tbody>
          <tr key="days">
            <th></th>
            <td>All</td>
            {Array.from(Array(7).keys()).map(pos => <td class={new Date(2018, 0, pos + 1).getDay() === 0 || new Date(2018, 0, pos + 1).getDay() === 6 ? "day-weekend" : ""}>{new Date(2018, 0, pos + 1).toLocaleDateString('en-US', { weekday: 'short' })}</td>)}
          </tr>
          {this.state.resources.map(resource =>
            <tr key={resource.name}>
              <th>{resource.name}</th>
              <td onClick={() => this.setDay(resource, 0)} className={resource.workingDays.includes(0)?'react-calendar__tile--active':''}></td>
              {Array.from(Array(7).keys()).map(pos => <td onClick={() => this.setDay(resource, -(pos + 1))} className={resource.workingDays.includes(-(pos + 1))?'react-calendar__tile--active':''}></td>)}
            </tr>
          )}
        </tbody>
      </table>

      </div>:<></>}</>
    );
  }

  updateCompanyStartTime(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, company: {...prevState.company, startTime: val + ":00"}}));
    this.saveCompanyHours();
  }

  updateCompanyEndTime(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, company: {...prevState.company, endTime: val + ":00"}}));
    this.saveCompanyHours();
  }

  async saveCompanyHours() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/hours`, {
      method: "PUT",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.company)
    });
    await response.json();
  }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderCalendarTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="calendar" />
        <h4 id="tabelLabel">Working calendar</h4>
        {contents}
        <div class="form-group">
          <label for="Input_BookingProfile">Resource booking profile</label>
          <select class="form-control" id="Input_BookingProfile" name="Input.BookingProfile"
            value={this.state.profileId ? this.state.profileId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profileId: parseInt(val)}));}}>
              <option value="0"></option>
              {this.state.profiles.map(profile => <option value={profile.id}>{profile.name}</option>)}
          </select>
        </div>
        <div>
          <label for="company-starttime">Working hours</label>
          <input id="company-starttime" type="time" name="company-starttime" step="60" value={this.state.company.startTime} onChange={evt => this.updateCompanyStartTime(evt)}/>
          <input id="company-endtime" type="time" name="company-endtime" step="60" value={this.state.company.endTime} onChange={evt => this.updateCompanyEndTime(evt)}/>
          <small>Can be overridden for days of week, resources, one day and combinations</small>
        </div>

        <div class="form-group">
          <fieldset>
            <legend>Lunch break:</legend>
            <label for="company-lbstarttime">Company lunch break hours</label>
            <input id="company-lbstarttime" type="time" name="company-lbstarttime" step="60" value="13:00:00"/>
            <input id="company-lbendtime" type="time" name="company-lbendtime" step="60" value="14:00:00"/>
            <div><label for="interval-is-floating">Interval is floating</label>
            <input type="checkbox" name="interval-is-floating"/>
            <label for="company-lblength">Interval length</label>
            <input id="company-lblength" type="number" name="company-lblength" value="1"/></div>
            <small>Can be overridden for days of week, resources, one day and combinations</small>
          </fieldset>
        </div>
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
        this.setState(prevState => ({...prevState, companyId: this.state.companies[0].id}));
        this.populateResourcesData(this.state.companyId);
        this.populateProfilesData(this.state.companyId);
    }
  }

  async populateResourcesData(companyId, month) {
    var selectedDate = new Date(this.state.date.getFullYear(), this.state.date.getMonth(), 1);
    var date = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000);
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/resources?month=${date.toLocaleDateString('en-US')}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resources: data, loading: false}));
  }

  async populateServicesData(companyId, resourceId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/${resourceId}/services`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, services: data, loading: false}));
  }

  async populateWorkingTimeData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/monthcalendar`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    if (data.length > 0)
      this.setState(prevState => ({...prevState, company: data[0]}));
  }

  async populateProfilesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/profiles`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, profiles: data, loading: false}));
  }
}
